import { render, staticRenderFns } from "./HomeMobileWhole.vue?vue&type=template&id=19647ca6&scoped=true"
import script from "./HomeMobileWhole.vue?vue&type=script&lang=js"
export * from "./HomeMobileWhole.vue?vue&type=script&lang=js"
import style0 from "./HomeMobileWhole.vue?vue&type=style&index=0&id=19647ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19647ca6",
  null
  
)

export default component.exports